import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  posts: [], // Changed to lowercase and empty array for safety
  error: null,
  message: null,
};

export const postsReducer = createReducer(initialState, (builder) => {
  builder
    /* --- Fetching Posts --- */
    .addCase("fetchPostsRequest", (state) => {
      state.loading = true;
    })
    .addCase("fetchPostsSuccess", (state, action) => {
      state.loading = false;
      state.posts = action.payload;
    })
    .addCase("fetchPostsFailure", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    /* --- Deleting Posts --- */
    .addCase("deletePostRequest", (state) => {
      state.loading = true;
    })
    .addCase("deletePostSuccess", (state, action) => {
      state.loading = false;
      state.message = action.payload; // Stores "Post deleted successfully" message
    })
    .addCase("deletePostFailure", (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    /* --- Utilities --- */
    .addCase("clearErrors", (state) => {
      state.error = null;
    })
    .addCase("clearMessage", (state) => {
      state.message = null;
    });
});